var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267.03,
    height: 149.383,
    viewBox: "0 0 267.03 149.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2212",
    x: 67.834,
    y: 0,
    width: 123.227,
    height: 149.383,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(-624.985 -622.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(49.485)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x1: 13.986,
    transform: "translate(576.5 704.5)",
    fill: "none",
    stroke: "#d5dfe9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 13.986,
    transform: "translate(827.544 704.5)",
    fill: "none",
    stroke: "#d5dfe9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x1: 79.719,
    transform: "translate(597.479 704.5)",
    fill: "none",
    stroke: "#d5dfe9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x2: 79.719,
    transform: "translate(740.832 704.5)",
    fill: "none",
    stroke: "#d5dfe9",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(-3986.829 -1283.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 101.358,
    height: 132.772,
    rx: 6,
    transform: "translate(4705.852 1907.456) rotate(2.384)",
    fill: "#d5dfe9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4611.81, 1905.85)",
    filter: "url(#Path_2212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2212-2",
    "data-name": "Path 2212",
    d: "M4823.988,1924.958l11.711,108.268a4.035,4.035,0,0,1-3.578,4.446l-92.745,10.032a4.036,4.036,0,0,1-4.446-3.578l-13.41-123.979a4.035,4.035,0,0,1,3.578-4.446l77.04-8.333a4.074,4.074,0,0,1,2.956.862l17.413,14.019a4.073,4.073,0,0,1,1.48,2.708Z",
    transform: "translate(-4649.16 -1905.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 24.725,
    height: 5.543,
    transform: "translate(4709.872 1923.412) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 25.021,
    height: 2.771,
    rx: 1.386,
    transform: "matrix(0.994, -0.108, 0.108, 0.994, 4696.926, 1957.844)",
    fill: "#ccd3dd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 14.721,
    height: 2.771,
    rx: 1.386,
    transform: "translate(4693.543 1926.572) rotate(-6.174)",
    fill: "#ccd3dd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1314",
    "data-name": "Rectangle 1314",
    width: 84.105,
    height: 17.96,
    transform: "translate(4694.51 1935.514) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1315",
    "data-name": "Rectangle 1315",
    width: 84.105,
    height: 7.247,
    transform: "translate(4697.352 1961.781) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1316",
    "data-name": "Rectangle 1316",
    width: 84.105,
    height: 43.808,
    transform: "translate(4698.259 1970.168) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 13.223,
    height: 5.543,
    transform: "translate(4763.865 1917.571) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 11.784,
    height: 5.543,
    transform: "translate(4698.512 1945.198) rotate(-6.174)",
    fill: "#23304a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 11.784,
    height: 5.543,
    transform: "translate(4711.724 1943.769) rotate(-6.174)",
    fill: "#23304a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1320",
    "data-name": "Rectangle 1320",
    width: 11.784,
    height: 5.543,
    transform: "translate(4724.937 1942.34) rotate(-6.174)",
    fill: "#c3e9c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 11.784,
    height: 5.543,
    transform: "translate(4738.149 1940.911) rotate(-6.174)",
    fill: "#ef9fa1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 11.784,
    height: 5.543,
    transform: "translate(4751.361 1939.482) rotate(-6.174)",
    fill: "#b2c3ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 11.784,
    height: 5.543,
    transform: "translate(4764.573 1938.053) rotate(-6.174)",
    fill: "#f8dc9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1324",
    "data-name": "Rectangle 1324",
    width: 16.226,
    height: 16.226,
    transform: "translate(4703.423 2017.911) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1325",
    "data-name": "Rectangle 1325",
    width: 16.226,
    height: 16.226,
    transform: "translate(4770.908 2010.611) rotate(-6.174)",
    fill: "#c3e9c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1326",
    "data-name": "Rectangle 1326",
    width: 46.561,
    height: 16.226,
    transform: "translate(4722.086 2015.892) rotate(-6.174)",
    fill: "#f4f6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M5038.223,1923.877l-17.691,1.914-1.915-17.7a3.989,3.989,0,0,1,1.255.678l17.414,14.019A3.984,3.984,0,0,1,5038.223,1923.877Z",
    transform: "translate(-252.127 -0.541)",
    fill: "#ccd3dd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.557,
    cy: 1.557,
    r: 1.557,
    transform: "translate(4685.687 2015.92)",
    fill: "#f8dc9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 3.929,
    cy: 3.929,
    r: 3.929,
    transform: "translate(4677.829 2019.033)",
    fill: "#f8dc9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 6.19,
    cy: 6.19,
    r: 6.19,
    transform: "translate(4800.375 1940.234)",
    fill: "#b2c3ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 2.028,
    cy: 2.028,
    r: 2.028,
    transform: "translate(4793.543 1936.178)",
    fill: "#b2c3ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAnalysis);
export default __webpack_public_path__ + "static/media/empty-analysis.21c7afa2c11c93b1b8fbdd795e825ba3.svg";
export { ForwardRef as ReactComponent };